/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it

require("fomantic-ui-css/semantic.min.css");
require("@fortawesome/fontawesome-free/css/fontawesome.min.css");
require("@fortawesome/fontawesome-free/css/brands.min.css");
require("@fortawesome/fontawesome-free/css/solid.min.css");
require("@fontsource/courgette/latin-400.css");
require("@fontsource/fredoka-one/latin-400.css");
require("@fontsource/raleway/latin-400.css");

// require("prismjs/themes/prism-solarizedlight.css");
require("prismjs/themes/prism.css");
require("./src/index.css");

const RELEASE_ROUTE_BASES = [
  "/releases/",
  "/fr/versions/",
  "/de/softwareveroffentlichung/",
  "/ja/リリース/",
];
const RELEASE_DETAIL_RE = /^screenpresso-\d+-\d+-\d+\/(?:summary\/)?$/;
const LOCALE_STORAGE_KEY = "language";

/**
 * Decodes a URL pathname without throwing when the browser gives us malformed
 * escape sequences.
 *
 * Example: "/ja/%E3%83%AA%E3%83%AA%E3%83%BC%E3%82%B9/" becomes "/ja/リリース/".
 */
function decodePathname(pathname) {
  try {
    return decodeURIComponent(pathname);
  } catch (error) {
    return pathname;
  }
}

/**
 * Infers the current site locale from a release route pathname.
 *
 * Example: "/fr/versions/" resolves to "fr"; "/releases/" resolves to "en".
 */
function releaseLocaleFromPathname(pathname) {
  if (pathname.indexOf("/fr/") === 0) {
    return "fr";
  }
  if (pathname.indexOf("/de/") === 0) {
    return "de";
  }
  if (pathname.indexOf("/ja/") === 0) {
    return "ja";
  }

  return "en";
}

/**
 * Checks whether a pathname belongs to one of the server-rendered release
 * routes that should bypass Gatsby client-side routing.
 */
function isReleaseRoute(pathname) {
  const decodedPathname = decodePathname(pathname);
  const normalizedPathname = decodedPathname.endsWith("/")
    ? decodedPathname
    : `${decodedPathname}/`;

  return RELEASE_ROUTE_BASES.some(basePath => {
    if (normalizedPathname === basePath) {
      return true;
    }

    return (
      normalizedPathname.indexOf(basePath) === 0 &&
      RELEASE_DETAIL_RE.test(normalizedPathname.slice(basePath.length))
    );
  });
}

/**
 * Converts a link href to a URL only when it points at the current origin.
 */
function getSameOriginUrl(href) {
  if (typeof window === "undefined") {
    return null;
  }

  const url = new URL(href, window.location.href);
  return url.origin === window.location.origin ? url : null;
}

/**
 * Installs a capture-phase click handler that forces release links through the
 * server so PHP can render the dynamic release page.
 */
function installReleaseRouteClickGuard() {
  document.addEventListener(
    "click",
    event => {
      if (
        event.defaultPrevented ||
        event.button !== 0 ||
        event.altKey ||
        event.ctrlKey ||
        event.metaKey ||
        event.shiftKey
      ) {
        return;
      }

      const link = event.target.closest && event.target.closest("a[href]");
      if (!link || link.download || (link.target && link.target !== "_self")) {
        return;
      }

      const url = getSameOriginUrl(link.href);
      if (!url || !isReleaseRoute(url.pathname)) {
        return;
      }

      try {
        window.localStorage.setItem(
          LOCALE_STORAGE_KEY,
          releaseLocaleFromPathname(decodePathname(url.pathname))
        );
      } catch (error) {
        // Continue navigation even if localStorage is unavailable.
      }

      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) {
        event.stopImmediatePropagation();
      }
      window.location.assign(url.href);
    },
    true
  );
}

/**
 * Reloads a release route from the server if Gatsby has already client-routed
 * to it from another page.
 */
function forceServerReleaseRoute(location) {
  const url = getSameOriginUrl(location && location.href ? location.href : "");
  if (!url || !isReleaseRoute(url.pathname)) {
    return;
  }

  try {
    window.localStorage.setItem(
      LOCALE_STORAGE_KEY,
      releaseLocaleFromPathname(decodePathname(url.pathname))
    );
  } catch (error) {
    // If localStorage is blocked, still prefer the server-rendered PHP page.
  }

  const key = `screenpresso:server-release-route:${url.pathname}${url.search}${url.hash}`;
  try {
    if (window.sessionStorage.getItem(key) === "1") {
      return;
    }

    window.sessionStorage.setItem(key, "1");
  } catch (error) {
    // If sessionStorage is blocked, still prefer the server-rendered PHP page.
  }

  window.location.replace(url.href);
}

/**
 * Gatsby browser hook that installs the release-route click guard once the app
 * starts in the browser.
 */
exports.onClientEntry = () => {
  installReleaseRouteClickGuard();
};

/**
 * Gatsby browser hook that repairs release routes after a client-side route
 * transition has already happened.
 */
exports.onRouteUpdate = ({ location, prevLocation }) => {
  if (prevLocation) {
    forceServerReleaseRoute(location);
  }
};
